/**
 * Update BNPL (Buy Now Pay Later) messaging when variant changes
 * Dispatches custom event for Klarna messaging update
 */
const updateBnpl = () => {
  // Dispatch custom event for Klarna messaging update
  const productScript = document.querySelector('[data-product-json]');
  if (productScript) {
    try {
      const productData = JSON.parse(productScript.innerHTML);
      const variantIdInput = document.querySelector('input[name="id"]');
      if (variantIdInput) {
        const variantId = Number(variantIdInput.value);
        const variant = productData.variants.find((v) => v.id === variantId);
        if (variant) {
          document.dispatchEvent(
            new CustomEvent('pdp:variantChanged', {
              detail: { variant },
            }),
          );
        }
      }
    } catch (e) {
      console.warn('[BNPL] Failed to dispatch variant change event:', e);
    }
  }
};

export default updateBnpl;
